export default __webpack_public_path__ + "static/media/flag.9f898403.svg";